import { render, staticRenderFns } from "./premiations.vue?vue&type=template&id=487b9b6a&scoped=true"
import script from "./premiations.vue?vue&type=script&lang=js"
export * from "./premiations.vue?vue&type=script&lang=js"
import style0 from "./premiations.vue?vue&type=style&index=0&id=487b9b6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487b9b6a",
  null
  
)

export default component.exports